import { Modal, Button } from "antd";
import "./EditMemberFieldModal.scss";
import { useEffect, useState } from "react";

export type MemberFieldType = "no" | "email" | "password" | "name";

export interface EditMemberFieldModalProps {
  visible: boolean;
  value: string;
  type: MemberFieldType;
  onCancel: () => void;
  onDone: (type: MemberFieldType, value: string) => void;
}

export default function EditMemberFieldModal({
  value,
  type,
  visible,
  onCancel,
  onDone,
}: EditMemberFieldModalProps) {
  const [val, setVal] = useState("");
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setVal(value);
    setLoading(false);
  }, [value, visible]);

  useEffect(() => {
    if (!visible) return;

    let current = "";
    if (type === "email") current = "email";
    else if (type === "name") current = "name";
    else if (type === "password") current = "password";

    setLabel(current);
  }, [type, visible]);

  return (
    <Modal
      className={"edit-name-modal clean one"}
      visible={visible}
      closable={false}
    >
      <header>
        <h2>Edit {label.charAt(0).toUpperCase() + label.slice(1)}</h2>
      </header>

      <input
        className={"lg"}
        value={val}
        type={type === "password" ? "password" : "text"}
        onChange={(ev) => setVal(ev.target.value)}
      />

      <footer>
        <Button className={"cancel"} size={"large"} onClick={onCancel}>
          <span>Cancel</span>
        </Button>
        <Button
          className={"primary"}
          size={"large"}
          loading={loading}
          disabled={!val}
          onClick={() => {
            setLoading(true);
            onDone(type, val);
          }}
        >
          <span>Save</span>
        </Button>
      </footer>
    </Modal>
  );
}
